/**
 *
 * MeasurementHistoryTable
 *
 */

import React, { Fragment } from "react"
import { Table } from "antd"
import { columns } from "./colums"
import alertSvg from "../../images/alert.svg"
import ModalCustom from "../ModalCustom"
import "./index.less"

/* eslint-disable react/prefer-stateless-function */
class MeasurementHistoryTable extends React.Component {
  state = {
    modalDeleteMeasure: false,
    idMeasureSelected: undefined,
  }

  setStateFrom = (name, value, ...rest) => {
    this.setState({
      [name]: value,
      idMeasureSelected: rest[0],
    })
  }

  showTotal = (total, range) => (
    <span style={{ color: "#A6A6A6" }}>{`Total mediciones: ${total}`}</span>
  )

  render() {
    return (
      <Fragment>
        <Table
          className="measurement-history-table"
          dataSource={this.props.dataSource}
          rowKey={(record) => record.id_measure}
          columns={columns(this.setStateFrom)}
          pagination={{
            pageSizeOptions: ["15", "25", "50", "100"],
            showSizeChanger: true,
            size: "default",
            defaultPageSize: 15,
            showTotal: this.showTotal,
          }}
        />
        <ModalCustom
          modalOpen={this.state.modalDeleteMeasure}
          showFooter
          onCancel={() => this.setStateFrom("modalDeleteMeasure", false)}
          onOk={() => {
            this.props.deleteMeasureWatcher(this.state.idMeasureSelected)
            this.setStateFrom("modalDeleteMeasure", false)
          }}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontSize: 14, fontWeight: 600 }}>
            ¿Estás seguro de que deseas eliminar esta medición?
          </span>
          {/* <p style={{ fontSize: 13}}>Esta será reenviada <strong>únicamente</strong> a aquellos colaboradores que aún no la han contestado.</p> */}
        </ModalCustom>
      </Fragment>
    )
  }
}

MeasurementHistoryTable.propTypes = {}

export default MeasurementHistoryTable
